import { IApplicationState } from '../../types/redux';

export const selectFiltersUrl = (state: IApplicationState) => {
  return state.filtersUrl;
};

export const selectListingUrl = (state: IApplicationState) => {
  return state.listingUrl;
};
